import { createFileRoute, Outlet, useMatch } from '@tanstack/react-router';
import { ResourceHub } from '../../components/resources/ResourceHub';
import { useSEO, useBreadcrumbSchema, PageSEO } from '../../lib/seo';

export const Route = createFileRoute('/resources/blog')({
  component: BlogPage,
});

function BlogPage() {
  const slugMatch = useMatch({ from: '/resources/blog/$slug', shouldThrow: false });

  useSEO(PageSEO.blog);
  useBreadcrumbSchema([
    { name: 'Home', url: '/' },
    { name: 'Blog', url: '/resources/blog' },
  ]);

  if (slugMatch) {
    return <Outlet />;
  }

  return <ResourceHub defaultType="blog" />;
}
